<template>
<div class="no-meeting-area area">

</div>
</template>

<script>

import mappings from "@/mappings/index";

export default {
  name: "NoMeeting"
}

</script>

<style scoped>

</style>